import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DailyInspiration = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const thoughts = [
    {
      id: 1,
      image: '/images/thoughts/thought6.jpg',
      quote: 'कामयाबी सुबह की तरह होती है... मांगने पर नहीं, जागने पर मिलती है।'
    },
    {
      id: 2,
      image: '/images/thoughts/thought7.jpg',
      quote: 'जो भरोसा एक बार बन जाए, वो हर कनेक्शन को मजबूत बना देता है।'
    },
    {
      id: 3,
      image: '/images/thoughts/thought8.jpg',
      quote: 'हर दिन एक नया अवसर है। मेहनत करते रहो, सफलता खुद तुम्हारे दरवाज़े पर आएगी।'
    },
    {
      id: 4,
      image: '/images/thoughts/thought9.jpg',
      quote: 'ज़िन्दगी हार जीत से नहीं, हौसलों से चलती है।'
    },
    {
      id: 5,
      image: '/images/thoughts/thought10.jpg',
      quote: 'हार तभी होती है, जब मान लिया जाए। जीत तभी होती है, जब ठान लिया जाए।'
    },
    {
      id: 6,
      image: '/images/thoughts/thought1.jpg',
      quote: 'कर्म ही धर्म है, और निरंतर प्रयास ही विजय का आधार है।'
    },
    {
      id: 7,
      image: '/images/thoughts/thought2.jpg',
      quote: 'अपनी मेहनत पर भरोसा रखो, किस्मत खुद-ब-खुद बदल जाएगी।'
    },
    {
      id: 8,
      image: '/images/thoughts/thought3.jpg',
      quote: 'हर कनेक्शन में विश्वास, हर चार्ज में RSD का साथ।'
    },
    {
      id: 9,
      image: '/images/thoughts/thought4.jpg',
      quote: 'जो सीखना कभी नहीं छोड़ता, वही सफलता की नई ऊँचाइयाँ छूता है।'
    },
    {
      id: 10,
      image: '/images/thoughts/thought5.jpg',
      quote: 'सकारात्मक सोच हर हार को सीख में बदल देती है।'
    }
  ];

  // Auto-rotate slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % thoughts.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [thoughts.length]);

  const handlePrev = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + thoughts.length) % thoughts.length);
  }, [thoughts.length]);

  const handleNext = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % thoughts.length);
  }, [thoughts.length]);

  return (
    <section className="py-10 md:py-14 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Simple Header */}
        <div className="text-center mb-6">
          <p className="text-orange-500 text-xs font-medium tracking-wider uppercase mb-1">आज का विचार</p>
          <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
            सोच जो बदले ज़िन्दगी
          </h2>
        </div>

        {/* Compact Carousel */}
        <div className="relative max-w-3xl mx-auto">
          {/* Image Container - Smaller */}
          <div className="relative aspect-[16/9] rounded-xl overflow-hidden shadow-lg">
            {thoughts.map((thought, index) => (
              <div
                key={thought.id}
                className={`absolute inset-0 transition-opacity duration-500 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img
                  src={thought.image}
                  alt={thought.quote}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}

            {/* Navigation Arrows - Smaller */}
            <button
              onClick={handlePrev}
              className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center shadow hover:bg-white transition-colors"
            >
              <ChevronLeft className="w-4 h-4 text-gray-700" />
            </button>
            <button
              onClick={handleNext}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center shadow hover:bg-white transition-colors"
            >
              <ChevronRight className="w-4 h-4 text-gray-700" />
            </button>

            {/* Slide Counter - Compact */}
            <div className="absolute bottom-2 right-2 bg-black/50 px-2 py-0.5 rounded text-xs text-white">
              {currentSlide + 1}/{thoughts.length}
            </div>
          </div>

          {/* Quote Below - Compact */}
          <div className="mt-4 text-center px-4">
            <p className="text-base md:text-lg text-gray-700 font-medium leading-relaxed">
              "{thoughts[currentSlide].quote}"
            </p>
            <p className="text-orange-500 text-xs mt-2">— RSD Accessories</p>
          </div>

          {/* Dots - Smaller */}
          <div className="flex justify-center gap-1.5 mt-4">
            {thoughts.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentSlide 
                    ? 'w-5 h-1.5 bg-orange-500' 
                    : 'w-1.5 h-1.5 bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyInspiration;
